export default {
  'id': '7x98QOdi',
  'date_created': '2017-06-27 09:18:54',
  'last_updated': '2018-02-14 11:19:31',
  'title': 'IHB-1489',
  'screenshot_url': 'https:\/\/s3.amazonaws.com\/hubs-images-test\/users\/99bae6a47c4f13aac72f38b\/screenshots\/1286',
  'icon_set_id': null,
  'type': 1,
  'disabled': null,
  'layout':{'favicon': null,
  'publication_id': 1286,
  'logo_image': null,
  'background_image': null,
  'background_blur':5,
  'menu_text_color': 'rgb(255, 255, 255)',
  'menu_background_color': 'rgb(37, 38, 39)',
  'sidebar_font': null,
  'section_title_font': null,
  'items_index_font': null,
  'item_title_font': null,
  'item_date_font': null,
  'item_body_font': null,
  'more_button_font': null,
  'hide_sidebar':0,
  'background_color': null,
  'hide_tile_labels': 1,
  'newswall_tile_width':290,
  'home_color': null,
  'home_icon_id': null,
  'home_icon_outer_size':40,
  'home_icon_inner_size':290,
  'home_icon_shape': 'square',
  'home_icon_use_bg_color': null,
  'home_icon_bg_color': '0',
  'home_icon_border': null,
  'home_icon_use_svg_color': null,
  'home_icon_svg_color': null,
  'hide_content_type_icons':0,
  'article_intro_images': 1,
  'show_filler_images': 1,
  'hide_header':0,
  'show_menu_bar':0,
  'full_screen':0,
  'hide_right_columns':0,
  'header_image': null,
  'header_color': null,
  'text_color': null,
  'hover_color': null,
  'hide_disqus':0,
  'hide_search':0,
  'hide_social':0},

   'sections':[
     {
       'id':2266,
      'title': 'Untitled 1',
      'sortorder': '1',
      'color': '#141415',
      'type': 'mixed',
      'icon': null,
      'sources':[{'name': '3dissue.com vvv',
      'url': 'https:\/\/www.3dissue.com\/feed',
      'type': 'feed',
      'owner': 1,
      'enabled': 1,
      'username': null,
      'source_id': 1235,
      'filter': null,
      'own_feed_flag':0,
      'favourites_flag':0,
      'playlists_flag':0,
      'likes_flag':0,
      'include_in_all_flag': 1,
      'hide_new_entries_flag':0,
      'source_featured_flag':0,
      'featured_period': 1,
      'featured_period_started_ts': null,
      'avatar_url': 'https:\/\/www.google.com\/s2\/favicons?domain=https:\/\/www.3dissue.com\/feed',
      'last_parsed': '2018-02-14 11:55:44',
      'parameters': null,
      'added_to_parse':false},{'name': 'Milan Design Week 2017',
      'url': 'https:\/\/www.pinterest.com\/wearedeltalight\/milan-design-week-2017\/',
      'type': 'pinterest',
      'owner':0,
      'enabled': 1,
      'username': 'wearedeltalight',
      'source_id': 1248,
      'filter': null,
      'own_feed_flag':0,
      'favourites_flag':0,
      'playlists_flag':0,
      'likes_flag':0,
      'include_in_all_flag': 1,
      'hide_new_entries_flag':0,
      'source_featured_flag':0,
      'featured_period': 1,
      'featured_period_started_ts': null,
      'avatar_url': 'http:\/\/i.pinimg.com\/upload\/401805666694006838_board_thumbnail_2017-04-26-06-52-20_93790_60.jpg',
      'last_parsed': '2018-02-14 12:05:10',
      'parameters': null,
      'added_to_parse':false}],

      'subsections': [
        {
          color : '#141415',
          date_created: '2018-02-14 12:31:39',
          deleted: null,
          featured: '0',
          icon: null,
          icon_bg_color: null,
          icon_border: '',
          icon_border_color: '',
          icon_border_style: '',
          icon_border_width: '',
          icon_id: null,
          icon_inner_size: '100',
          icon_outer_size: '40',
          icon_shape: 'square',
          icon_svg_color: null,
          icon_use_bg_color: '0',
          icon_use_svg_color: null,
          id: 4964,
          json_url: 'https://test-hubs.3dissue.net/api/1286/sections/4964/items',
          last_updated: '2018-02-14 12:31:44',
          parent_id: 2266,
          pub_id: 1286,
          publication_id: null,
          rss_url: 'https://test-hubs.3dissue.net/1286/section/4964?format=rss',
          sortorder: '0',
          sources: [],
          subsections: [],
          title: 'Subsection',
          type: 'articles',
          use_icon_border: '0',
          use_icon_defaults: '1',
        },
        {
          color : '#141415',
          date_created: '2018-02-14 12:31:39',
          deleted: null,
          featured: '0',
          icon: null,
          icon_bg_color: null,
          icon_border: '',
          icon_border_color: '',
          icon_border_style: '',
          icon_border_width: '',
          icon_id: null,
          icon_inner_size: '100',
          icon_outer_size: '40',
          icon_shape: 'square',
          icon_svg_color: null,
          icon_use_bg_color: '0',
          icon_use_svg_color: null,
          id: 4164,
          json_url: 'https://test-hubs.3dissue.net/api/1286/sections/4964/items',
          last_updated: '2018-02-14 12:31:44',
          parent_id: 2266,
          pub_id: 1286,
          publication_id: null,
          rss_url: 'https://test-hubs.3dissue.net/1286/section/4964?format=rss',
          sortorder: '0',
          sources: [],
          subsections: [],
          title: 'Subsection 1',
          type: 'articles',
          use_icon_border: '0',
          use_icon_defaults: '1',
        },

      ],

      'date_created': '2017-06-27 09:18:54',
      'last_updated': '2017-06-27 09:18:54',
      'use_icon_defaults': '1',
      'icon_id': null,
      'icon_outer_size': '40',
      'icon_inner_size': '100',
      'icon_shape': 'square',
      'icon_use_bg_color': '0',
      'icon_border': '',
      'icon_use_svg_color': null,
      'icon_svg_color': null,
      'icon_border_width': '',
      'icon_border_style': '',
      'icon_border_color': '',
      'use_icon_border': '0',
      'json_url': 'https:\/\/test-hubs.3dissue.net\/api\/1286\/sections\/2266\/items',
      'rss_url': 'https:\/\/test-hubs.3dissue.net\/1286\/section\/2266?format=rss',
      'parent_id': null
    },


     {'id':2267,
      'title': 'Titled',
      'sortorder': '1',
      'color': '#141415',
      'type': 'mixed',
      'icon': null,
      'sources':[{'name': '3dissue.com vvv',
      'url': 'https:\/\/www.3dissue.com\/feed',
      'type': 'feed',
      'owner': 1,
      'enabled': 1,
      'username': null,
      'source_id': 1235,
      'filter': null,
      'own_feed_flag':0,
      'favourites_flag':0,
      'playlists_flag':0,
      'likes_flag':0,
      'include_in_all_flag': 1,
      'hide_new_entries_flag':0,
      'source_featured_flag':0,
      'featured_period': 1,
      'featured_period_started_ts': null,
      'avatar_url': 'https:\/\/www.google.com\/s2\/favicons?domain=https:\/\/www.3dissue.com\/feed',
      'last_parsed': '2018-02-14 11:55:44',
      'parameters': null,
      'added_to_parse':false},{'name': 'Milan Design Week 2017',
      'url': 'https:\/\/www.pinterest.com\/wearedeltalight\/milan-design-week-2017\/',
      'type': 'pinterest',
      'owner':0,
      'enabled': 1,
      'username': 'wearedeltalight',
      'source_id': 1248,
      'filter': null,
      'own_feed_flag':0,
      'favourites_flag':0,
      'playlists_flag':0,
      'likes_flag':0,
      'include_in_all_flag': 1,
      'hide_new_entries_flag':0,
      'source_featured_flag':0,
      'featured_period': 1,
      'featured_period_started_ts': null,
      'avatar_url': 'http:\/\/i.pinimg.com\/upload\/401805666694006838_board_thumbnail_2017-04-26-06-52-20_93790_60.jpg',
      'last_parsed': '2018-02-14 12:05:10',
      'parameters': null,
      'added_to_parse':false}],

      'subsections': [
        {
          color : '#141415',
          date_created: '2018-02-14 12:31:39',
          deleted: null,
          featured: '0',
          icon: null,
          icon_bg_color: null,
          icon_border: '',
          icon_border_color: '',
          icon_border_style: '',
          icon_border_width: '',
          icon_id: null,
          icon_inner_size: '100',
          icon_outer_size: '40',
          icon_shape: 'square',
          icon_svg_color: null,
          icon_use_bg_color: '0',
          icon_use_svg_color: null,
          id: 5964,
          json_url: 'https://test-hubs.3dissue.net/api/1286/sections/4964/items',
          last_updated: '2018-02-14 12:31:44',
          parent_id: 2266,
          pub_id: 1286,
          publication_id: null,
          rss_url: 'https://test-hubs.3dissue.net/1286/section/4964?format=rss',
          sortorder: '0',
          sources: [],
          subsections: [],
          title: 'Subsection',
          type: 'articles',
          use_icon_border: '0',
          use_icon_defaults: '1',
        },
        {
          color : '#141415',
          date_created: '2018-02-14 12:31:39',
          deleted: null,
          featured: '0',
          icon: null,
          icon_bg_color: null,
          icon_border: '',
          icon_border_color: '',
          icon_border_style: '',
          icon_border_width: '',
          icon_id: null,
          icon_inner_size: '100',
          icon_outer_size: '40',
          icon_shape: 'square',
          icon_svg_color: null,
          icon_use_bg_color: '0',
          icon_use_svg_color: null,
          id: 4864,
          json_url: 'https://test-hubs.3dissue.net/api/1286/sections/4964/items',
          last_updated: '2018-02-14 12:31:44',
          parent_id: 2266,
          pub_id: 1286,
          publication_id: null,
          rss_url: 'https://test-hubs.3dissue.net/1286/section/4964?format=rss',
          sortorder: '0',
          sources: [],
          subsections: [],
          title: 'Subsection 1',
          type: 'articles',
          use_icon_border: '0',
          use_icon_defaults: '1',
        }
      ],
    }
  ],

  'readonly': null,
  'url': 'https:\/\/test-hubs.3dissue.net\/7x98QOdi',
  'rss_url': 'https:\/\/test-hubs.3dissue.net\/7x98QOdi?format=rss',
  'json_url': 'https:\/\/test-hubs.3dissue.net\/api\/7x98QOdi\/items',
};



// WEBPACK FOOTER //
// /Users/nide/Code/3dissue/3d-issue-hubs-ui/src/app/manage-content/fixtures/publication-sections.ts